<script lang="ts">
import { computed, defineComponent } from "vue";

const ICON_SPRITE_SVG: string = require("@/assets/static/images/icon-sprite.svg");

export default defineComponent({
  name: "IconSprite",
  props: {
    iconName: {
      type: String,
      required: true,
    },
    istGross: {
      type: Boolean,
      default: false,
    },
    istKlein: {
      type: Boolean,
      default: false,
    },
    cssKlassen: {
      type: String,
      default: "",
    },
    cssStyle: {
      type: String,
      default: "",
    },
  },
  setup(props) {
    const alleCssKlassen = computed(() => {
      return (
        "c-icon" +
        (props.istGross ? " c-icon--large" : "") +
        (props.istKlein ? " c-icon--small" : "") +
        (props.cssKlassen ? " " + props.cssKlassen : "")
      );
    });

    function iconPfad(icon: string) {
      return ICON_SPRITE_SVG + "#" + (icon.startsWith("icon-") ? icon : "icon-" + icon);
    }

    const istCollapseElement = computed(() => {
      // Bei SVG mit Klasse c-collapse__icon und Icon=icon-arrow-up zusätzlich ein arrow-down liefern
      return props.cssKlassen.indexOf("c-collapse__icon") !== -1 && props.iconName === "icon-arrow-up";
    });

    return {
      props,
      alleCssKlassen,
      iconPfad,
      istCollapseElement,
    };
  },
});
</script>

<template>
  <svg focusable="false" :class="alleCssKlassen" :style="cssStyle" aria-hidden="true">
    <use :class="{ 'c-collapse__icon--up': istCollapseElement }" :xlink:href="iconPfad(props.iconName)" />
    <!-- Beim Collapse-Element zusätzlich ein arrow-down liefern -->
    <use
      v-if="istCollapseElement"
      :class="{ 'c-collapse__icon--down': istCollapseElement }"
      :xlink:href="iconPfad('icon-arrow-down')"
    />
  </svg>
</template>

<style scoped></style>
